import script from "./azureCallback.vue?vue&type=script&setup=true&lang=ts"
export * from "./azureCallback.vue?vue&type=script&setup=true&lang=ts"

import "./azureCallback.vue?vue&type=style&index=0&id=6874687a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6874687a"]])

export default __exports__